module.exports = __webpack_public_path__ + "BrightShaw.webp?3b68a8503a21bfc36662b7faf788fab2";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/BrightShaw.webp
// module id = 54
// module chunks = 0